<template>
    <div :class="getCSSClass('repository-upload-component-container')">
        <div :class="getCSSClass('repository-manager-function-popup-row')">
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <div style="display: flex; flex-direction: column; width: 100%">
                    <label v-html="translate('Feltöltendő állomány(ok)')"></label>
                    <label :class="getCSSClass('edit-form-label-tooltip')"
                           v-html="translate('Számítógépről feltöltéskor a kiválasztott állományok összesített mérete nem haladhatja meg a :limit MB-ot', {limit: this.totalLimit})"></label>
                    <label v-if="!allowUpload"
                           :class="getCSSClass('editform-validation-error-label-message')"
                           v-html="translate('Teljes méret: :size', {size: totalSizeMb})"></label>
                </div>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <div style="display: flex; flex-direction: column; width: 100%">
                    <div style="display: flex; flex-direction: row; width: 100%">
                        <select readonly size="5" style="background-image: unset" :ref="'filelist'">
                            <option v-for="filename in filenames" v-html="filename"></option>
                        </select>
                        <div :class="getCSSClass('repository-manager-upload-source-buttons-container')">
                            <label for="fileinput" class="button" :class="getCSSClass('repository-upload-button')">
                                <input type="file"
                                       v-on:change="handleFileinputChange"
                                       id="fileinput"
                                       :multiple="multiple"
                                       :accept="accept"
                                       style="margin: 0; padding: 0; border: 0; opacity: 0; height: 0; width: 0"
                                >
                                <span class="button" style="width: 100%"
                                        v-html="icon('browse')+' '+translate('Tallózás a számítógépen')"></span>
                            </label>
                            <button  type="button"
                                     v-on:click="removeSelectedUpload"
                                     :class="getCSSClass('repository-remove-file-button')"
                                     :label="translate('Kijelölt fájl törlése')"
                                     v-html="icon('remove')"></button>
                            <button  type="button"
                                     v-on:click="browseInbox"
                                     :class="getCSSClass('repository-upload-button')"
                                     v-html="icon('browse')+translate('Tallózás az SFTP tárhelyen')"></button>
                        </div>
                    </div>
                    <div style="width: 100%; padding-top: .5rem">
                        <label :class="getCSSClass('edit-form-label-tooltip')"
                                v-html="icon('tooltip')+' '+translate('Feltöltés VAGY a számítógépről VAGY a beérkező fájlok SFTP tárhelyen levő mappájából történhet.')"></label>
                    </div>
                </div>
            </div>
        </div>
        <div :class="getCSSClass('repository-manager-function-popup-row')">
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Célmappa')"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <repository-folder-picker :repository="repository"
                                          :operations-url="operationsUrl"
                                          :starting-path="currentPath"
                                          v-on:path="path = $event"
                                          ></repository-folder-picker>

            </div>

        </div>
        <div :class="getCSSClass('repository-manager-function-popup-row')"
             v-for="componentProperties, component in additionalComponents"
        >
            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate(componentProperties.label)"></label></div>
            <div :class="getCSSClass('repository-manager-function-popup-column')">
                <component :is="componentProperties.component"
                           :key="componentKey"
                           v-model="additionalComponentData[component]"
                           v-bind="componentProperties.props"></component>
            </div>

        </div>
        <div :class="getCSSClass('repository-manager-upload-buttons-container')">
            <button :class="getCSSClass('repository-manager-popup-save-button')"
                    v-on:click="uploadFiles"
                    :disabled="!allowUpload || uploading"
            ><span v-html="icon('upload')" class="mr-2"></span><span v-html="translate('Feltöltés')"></span>
            </button>
            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                    v-on:click="$emit('close')"
            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Bezár')"></span>
            </button>
            <div style="margin-left: auto; position: relative"
                 :class="getCSSClass('repository-manager-upload-status-display')">
                <div style="height: 100%"
                     :ref="'progressbar'"
                     :class="getCSSClass('repository-manager-upload-status-progress-bar-back', 'bg-gray-200')">
                </div>
                <div style="position: absolute; width: 100%; height: 100%; display: flex; top: 0; left: 0; justify-content: center; align-items: center; background-color: rgba(0,0,0,0); z-index: 10"
                     :class="getCSSClass('repository-manager-upload-status-progress-bar-front')"
                     v-html="currentUploadedFile"
                ></div>
            </div>
        </div>


        <popup :visible="showInboxPopup"
               v-on:close="showInboxPopup = false">
            <div :class="getCSSClass('repository-upload-component-inbox-browser-container')">
                <div class="w-full flex">
                    <div class="w-1/2 flex flex-col">
                        <div style="margin-bottom: .5rem; display: flex; justify-content: space-between; width: 100%; align-items: center"
                        >
                            <label v-html="translate('Mappák')" style="margin-bottom: .5rem"></label>
                        </div>
                    </div>
                    <div class="w-1/2 flex flex-col">
                        <div style="margin-bottom: .5rem; display: flex; justify-content: space-between; width: 100%; align-items: center"
                        >
                            <label v-html="translate('Fájlok')"></label>
                            <button @click="selectAllInboxFiles" v-html="translate('Összes kijelölése')"></button>
                        </div>
                    </div>
                </div>
                <div class="w-full flex">
                    <div class="w-1/2 flex flex-col">
                        <div :class="getCSSClass('repository-upload-component-inbox-folders-container')"
                        >
                            <div v-if="inboxPath.length > 0"
                                 @click="inboxPath.pop()"
                                 :class="getCSSClass('repository-upload-component-inbox-folder-row')"><i class="far fa-arrow-up"></i></div>
                            <div v-for="folder in inboxFolders"
                                 @click="inboxPath.push(folder)"
                                 :class="getCSSClass('repository-upload-component-inbox-folder-row')"
                                 v-html="folder"
                            ></div>
                        </div>
                    </div>
                    <div class="w-1/2 flex flex-col">
                        <select readonly size="25"
                                :class="getCSSClass('repository-upload-component-inbox-browser-select')"
                                multiple="multiple"
                                style="background-image: unset"
                                v-model="selectedInboxFiles">
                            <option v-for="file, index in inboxFiles" v-html="file.name" :value="index"></option>
                        </select>
                    </div>
                </div>
            </div>
            <div :class="getCSSClass('repository-manager-inbox-path-container')">
                <template v-for="p, index in inboxPath">

                    <span v-if="index < inboxPath.length - 1"
                          :class="getCSSClass('repository-manager-inbox-path-element')"
                      role="button"
                      @click="inboxPath = inboxPath.slice(0, index + 1)"
                      v-html="p"
                    ></span>
                    <span v-else v-html="p"></span>
                </template>
            </div>
            <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                <button :class="getCSSClass('repository-manager-popup-save-button')"
                        v-on:click="addInboxFiles"
                ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Kiválasztás')"></span>
                </button>
                <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                        v-on:click="showInboxPopup = false"
                ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                </button>
                <span v-html="loadingIndicator"
                      v-show="scanningInbox"
                      :style="{'opacity': scanningInbox ? 1 : 0}"></span>

            </div>

        </popup>
    </div>
</template>

<script>
    import {ajaxUploadMixin} from "./mixins/ajaxUploadMixin";
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        mixins: [ajaxUploadMixin],
        props: {
            operationsUrl: {type: String},
            repository: {type: Object},
            multiple: {type: Boolean, default: true},
            additionalComponents: {type: Object, default: () => {return {}}},
            currentPath: {},
            accept: {type: String, default: ''},
            totalLimit: {type: Number, default: 32}
        },
        data: function () {
            return {
                files: [],
                path: [],
                showInboxPopup: false,
                inboxFolders: [],
                inboxFiles: [],
                inboxPath: [],
                selectedInboxFiles: [],
                mode: 'upload',
                uploadPercentage: 0,
                currentUploadedFile: '',
                additionalComponentData: {},
                componentKey: Math.random(),
                scanningInbox: false,
                checkTimeout: null,
                uploading: false,
            }
        },
        created() {
            Object.keys(this.additionalComponents).forEach((key) => {
                Vue.set(this.additionalComponentData, key, this.additionalComponents[key].default);
            })
        },
        mounted() {
            this.path = this.currentPath;
        },
        methods: {
            selectAllInboxFiles: function() {
                let s = [];
                this.inboxFiles.forEach((i, index) => {
                    s.push(index);
                });
                this.selectedInboxFiles = s;
            },
            removeSelectedUpload:function() {
                let selected = this.$refs['filelist'].value;
                if (!selected) {
                    return;
                }
                this.files = this.files.filter((i) => {
                    return i.name != selected;
                });
            },
            handleFileinputChange: function(event) {
                //this.files = [];
                this.mode = 'upload';
                Array.from(event.target.files).forEach((file) => {
                    this.files.push(file);
                })
            },
            addInboxFiles: function() {
                this.files = [];
                this.mode = 'inbox';
                this.selectedInboxFiles.forEach((fileIndex) => {
                    this.files.push(this.inboxFiles[fileIndex]);
                });
                this.showInboxPopup = false;
                this.selectedInboxFiles = [];
            },
            browseInbox: function() {
                if (this.inboxPath.length == 0) {
                    this.scanInbox(() => {
                        this.showInboxPopup = true;
                    });
                } else {
                    this.inboxPath = [];
                    this.showInboxPopup = true;
                }
            },
            scanInbox: function(callback = null) {
                this.scanningInbox = true;
                this.selectedInboxFiles = [];
                window.axios.post(this.operationsUrl, {operation: 'scanInbox', path: this.inboxPath})
                    .then((response) => {
                        this.inboxFiles = response.data.files;
                        this.inboxFolders = response.data.folders;
                        if (callback) {
                            callback();
                        }
                        this.scanningInbox = false;
                    });
            },
            uploadFiles: async function() {
                let queue = [];
                let vm = this;
                this.uploading = true;
                if (this.mode == 'inbox') {
                    window.axios.post(this.operationsUrl, {
                        operation: 'uploadFiles',
                        mode: this.mode,
                        files: this.files,
                        path: this.path,
                        inboxPath: this.inboxPath,
                        additionalComponentData: this.additionalComponentData
                    }).then((response) => {
                        this.checkTimeout = window.setInterval(() => {
                            window.axios.post(this.operationsUrl, {
                                operation: 'checkUploads'
                            }).then((response) => {
                                this.currentUploadedFile = response.data;
                                if (this.currentUploadedFile == '') {
                                    this.files = [];
                                    this.uploading = false;
                                    window.clearInterval(this.checkTimeout);
                                    this.$emit('saved', response.data);
                                    this.$emit('close');
                                }
                            })
                        }, 1500);
                    });
                } else {
                    for (let index = 0; index < this.files.length; index++) {
                        this.currentUploadedFile = this.files[index].name;
                        let uploaded = await this.uploadFileAsync(this.files[index], (event) => {
                            vm.uploadPercentage = event.detail.pos / event.detail.size * 100;
                            vm.$refs['progressbar'].style.width = vm.uploadPercentage+'%';
                        });
                        queue.push({
                            name: this.files[index].name,
                            type: this.files[index].type,
                            id: uploaded,
                        });
                        this.currentUploadedFile = '';
                        this.uploadPercentage = 0;
                        this.$refs['progressbar'].style.width = this.uploadPercentage+'%';
                    }
                    window.axios.post(this.operationsUrl, {
                        operation: 'uploadFiles',
                        mode: this.mode,
                        files: queue,
                        path: this.path,
                        inboxPath: this.inboxPath,
                        additionalComponentData: this.additionalComponentData
                    }).then((response) => {
                        this.files = [];
                        this.uploading = false;
                        this.$emit('saved', response.data);
                        this.$emit('close');
                        window.clearInterval(this.checkTimeout);
                    });
                }

            },
        },
        computed: {
            filenames: function() {
                return this.files.map((file) => {
                    return file.name;
                });
            },
            allowUpload: function() {
                return this.currentUploadedFile != '' || Math.ceil(this.totalSize) <= this.totalLimit * 1024 * 1024 * 1024;
            },
            totalSizeMb: function() {
                return Math.ceil(this.totalSize / (1024 * 1024)).toString()+'MB';
            },
            totalSize: function() {
                if (this.mode == 'inbox') {
                    return 0;
                }
                return this.files.reduce((total, file) => {
                    return total + file.size;
                }, 0);
            }
        },
        watch: {
            inboxPath: function() {
                this.scanInbox();
            }
        }

    }
</script>
